import React from 'react';
import Yup from '~/util/yup';
import { useQuery } from '@tanstack/react-query';
import { SelectFormField } from '~/shared/forms/controls/fields/SelectFormField';
import { FormModal } from '~/shared/forms/FormModal';
import { getPreregisteredUserOptions, registerPreregisteredUserOptions, UserTypeEnum, UserTypeOptions } from '@generated';
import { TextFormField } from '~/shared/forms/controls/fields/text-fields/TextFormField';
import { LoadingScreen } from '~/shared/LoadingScreen';

const validationSchema = Yup.object().shape({
	emailAddress: Yup.string().label('Email Address').nullable().required(),
	firstName: Yup.string().label('First Name').nullable().required(),
	lastName: Yup.string().label('Last Name').nullable().required(),
	primaryUserTypeId: Yup.string().label('Primary User Type').nullable().required()
});

export function RegisterUserFormModal() {
	const {
		data: preregisteredUser,
		isLoading,
		error
	} = useQuery({
		...getPreregisteredUserOptions(),
		staleTime: 0,
		gcTime: 0
	});

	if (isLoading) {
		return <LoadingScreen message="Loading your registration details..." />;
	}

	if (error || !preregisteredUser) {
		throw new Error('We could not load your registration details. Please refresh the page or contact support.');
	}

	const filteredUserTypes = UserTypeOptions.filter(x => x.id !== UserTypeEnum.Administrator);

	return (
		<FormModal
			title="Register"
			initialValues={{
				emailAddress: preregisteredUser.emailAddress,
				firstName: preregisteredUser.firstName,
				lastName: preregisteredUser.lastName,
				primaryUserTypeId: null
			}}
			saveMutation={registerPreregisteredUserOptions}
			onSuccess={() => {
				window.location.reload();
			}}
			validationSchema={validationSchema}
		>
			{formHelpers => {
				return (
					<div className="grid grid-cols-1 gap-4">
						<TextFormField name="emailAddress" label="Email Address" isReadOnly />
						<TextFormField name="firstName" label="First Name" />
						<TextFormField name="lastName" label="Last Name" />
						<SelectFormField name="primaryUserTypeId" options={filteredUserTypes} />
					</div>
				);
			}}
		</FormModal>
	);
}
